export default __webpack_public_path__ + "static/media/redMarker.eab8bb4c.svg";